module.exports = __webpack_public_path__ + "static/Pt14-9d804d0fd42f8f81fd22990c1c7a0ede.jpg";